export default __webpack_public_path__ + "static/media/DNo.20-6.2ae418a3.jpg";